import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate} from "react-router-dom";
import Home from "./pages/Home";
import ArticleDetail from "./components/ArticleDetail.js";
import Layout from "./components/Layout";
import "./styles/main.css";
import New from "./components/New";
import PrivacyPolicy from "./components/PrivacyPolicy.js";
import TermsAndConditions from "./components/TermsandConditions.js";
import AboutUs from "./pages/AboutUs.js";
import Contact from "./pages/Contact.js";
import ScrollButtons from "./components/ScrollButtons";
import Login from "./pages/Login.js";
import Signup from "./pages/Signup";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LikeButton from "./pages/LikeButton.js";
import ForgotPassword from "./pages/ForgotPassword.js";
import ResetPassword from "./pages/ResetPassword.js";
import ChangePassword from "./pages/ChangePassword.js";
import Profile from "./pages/Profile.js";
import { ThemeProvider } from "./context/ThemeContext"; 

const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  return !user ? children : <Navigate to="/" />;
};
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
};

const LoginPopup = ({ onClose, onLoginClick, onSignupClick }) => {
  return (
    <div className="login-popup-overlay">
      <div className="login-popup">
        <button className="login-popup-close" onClick={onClose}>
          ×
        </button>
        <h2>Join Our Community</h2>
        <p>
          Sign in or create an account to access exclusive content and features
        </p>
        <div className="login-popup-buttons">
          <button className="btn-primary" onClick={onLoginClick}>
            Login
          </button>
          <button className="btn-secondary" onClick={onSignupClick}>
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

function AppContent() {
  const { user } = useAuth();
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [popupTimer, setPopupTimer] = useState(null);
  useEffect(() => {
    if (!user) {
      const timer = setTimeout(() => {
        setShowLoginPopup(true);
      }, 20000); 
      setPopupTimer(timer);
      return () => {
        if (timer) clearTimeout(timer);
      };
    } else {
      if (popupTimer) clearTimeout(popupTimer);
      setShowLoginPopup(false);
    }
  }, [user]);
  const handleClosePopup = () => {
    setShowLoginPopup(false);
    if (popupTimer) clearTimeout(popupTimer);
  };
  const handleLoginClick = () => {
    window.location.href = "/login";
  };
  const handleSignupClick = () => {
    window.location.href = "/signup";
  };

  return (
    <Router>
      {showLoginPopup && (
        <LoginPopup
          onClose={handleClosePopup}
          onLoginClick={handleLoginClick}
          onSignupClick={handleSignupClick}
        />
      )}
      <Layout>
        <ScrollToTop />
        <ScrollButtons />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:categoryName?" element={<Home />} />
          <Route path="/article/:id" element={<ArticleDetail />} />
          <Route path="/news" element={<New />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/like" element={<LikeButton />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route
            path="/termsandconditions"
            element={<TermsAndConditions />}
          />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/signup"
            element={
              <PublicRoute>
                <Signup />
              </PublicRoute>
            }
          />
        </Routes>
      </Layout>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;